import { ApplicationPill } from './application-type-pill.component';

export const RECON_TYPE_LABEL: ApplicationPill = {
  label: 'Reconsideration',
  shortLabel: 'RECON',
  backgroundColor: '#fff',
  borderColor: '#454545',
  textColor: '#000',
};

export const MODIFICATION_TYPE_LABEL: ApplicationPill = {
  label: 'Modification',
  shortLabel: 'MODI',
  backgroundColor: '#fff',
  borderColor: '#45F4F4',
  textColor: '#000',
};

export const RETROACTIVE_TYPE_LABEL = {
  label: 'Retroactive',
  code: 'RETRO',
  shortLabel: 'RETRO',
  backgroundColor: '#94C6AC',
  borderColor: '#94C6AC',
  description: 'Notice of Intent is Retroactive',
  textColor: '#002F17',
};

export const DRAFT_DECISION_TYPE_LABEL = {
  label: 'Draft',
  code: 'Draft',
  shortLabel: 'Draft',
  backgroundColor: '#FEE9B5',
  borderColor: '#FEE9B5',
  description: 'Draft',
  textColor: '#000',
};

export const RELEASED_DECISION_TYPE_LABEL = {
  label: 'Released',
  code: 'Released',
  shortLabel: 'Released',
  backgroundColor: '#A7C7E8',
  borderColor: '#A7C7E8',
  description: 'Draft',
  textColor: '#000',
};

export const DECISION_CONDITION_INCOMPLETE_LABEL = {
  label: 'Incomplete',
  shortLabel: 'INCD',
  backgroundColor: '#fff',
  borderColor: '#fcba19',
  textColor: '#000',
};

export const DECISION_CONDITION_ONGOING_LABEL = {
  label: 'Ongoing',
  shortLabel: 'ONGO',
  backgroundColor: '#fff',
  borderColor: '#003366',
  textColor: '#000',
};

export const DECISION_CONDITION_COMPLETE_LABEL = {
  label: 'Complete',
  shortLabel: 'COMD',
  backgroundColor: '#fff',
  borderColor: '#065a2f',
  textColor: '#000',
};

export const DECISION_CONDITION_PASTDUE_LABEL = {
  label: 'Past Due',
  shortLabel: 'PAST',
  backgroundColor: '#fff',
  borderColor: '#fcba19',
  textColor: '#000',
};

export const DECISION_CONDITION_PENDING_LABEL = {
  label: 'Pending',
  shortLabel: 'PEND',
  backgroundColor: '#fff',
  borderColor: '#A7C7E8',
  textColor: '#000',
};

export const DECISION_CONDITION_EXPIRED_LABEL = {
  label: 'Expired',
  shortLabel: 'EXPI',
  backgroundColor: '#fff',
  borderColor: '#c6242a',
  textColor: '#000',
};

export const DECISION_CONDITION_SUPERSEDED_LABEL = {
  label: 'Superseded',
  shortLabel: 'SUPD',
  backgroundColor: '#fff',
  borderColor: '#C08106',
  textColor: '#000',
};

export const OPEN_PR_LABEL = {
  label: 'Open',
  shortLabel: 'Open',
  backgroundColor: '#94c6ac',
  borderColor: '#94c6ac',
  textColor: '#313132',
};

export const CLOSED_PR_LABEL = {
  label: 'Closed',
  shortLabel: 'Closed',
  backgroundColor: '#DD8C8F',
  borderColor: '#DD8C8F',
  textColor: '#313132',
};

export const CONDITION_LABEL = {
  label: 'Condition',
  shortLabel: 'COND',
  backgroundColor: '#fff',
  borderColor: '#454545',
  textColor: '#000',
};
